import React from "react";
import RequestActions from "./Card-Components/RequestActions";
import RequestInformation from "./Card-Components/RequestInformation";
function RequestCard(props) {
  let { request, fetchActiveRequests } = props;

  //manage feedback status for indivisual App
  //Based on request.status is 0 or 1,
  //if status===0 then feedback is pending move to timeline status 7
  //if  status===1 it means feedback given move to timeline status 8
  if (request.request.request_timeline_status === 8) {
    request = {
      ...request,
      request: {
        ...request.request,
        request_timeline_status: request.status === 0 ? 7 : 8,
      },
    };
  }

  return (
    <div>
      <div className="request-link mt-4">
        <div className="rounded-box p-3 pb-30  ">
          <RequestInformation request={request} />
          <RequestActions
            request={request}
            fetchActiveRequests={fetchActiveRequests}
          />
        </div>
      </div>
    </div>
  );
}

export default RequestCard;
